<template>
    <div class="jczdView">
        <!--顶部的导航问题提示 及 关闭按钮-->
        <div class="topNav"  v-if="typeName&&typeName!=''">
            <!--左 logo-->
            <div class="topNavLogo">
                <img :src="imgObj.sseLogin" alt="">
            </div>
            <!--文字-->
            <div class="topNavText">
                <p>
                    <span>为您{{ typeName }}</span>
                    <span class="blueSpan">“{{ questionText }}”</span>
                    <span>问题</span>
                </p>
            </div>
            <!--关闭按钮-->
            <div class="topNavClose" @click="closeSSE">×</div>
        </div>
        <!--问的问题及复制-->
        <div class="topQuestionAndCopy">
            <div class="questionContent">
                <div class="questionText">{{ questionText }}</div>
                <div class="questionCopy" @click="copyQuestion">复制</div>
            </div>
        </div>
        <!--sse markdown-->
        <div class="showMarkDown" :style="markdownH!=''?'height:' + markdownH + '!important;':''">
            <div class="markDownVontent" v-if="markdownText!=''">
                <NnitMarkdown
                id="notData"
                :source="markdownText"
                :showLine="false"/>
            </div>
        </div>
        <div class="aiText">
            <p v-if="sseStatus == 3">以上答案由AI初步训练生成，点击“重新生成”，答案会更加精准、更加完善。</p>
        </div>
        <!--收藏 复制 重新生成 继续生成 暂停生成-->
        <div class="bottomHandle">
            <div class="bHandleLeft" v-if="sseStatus == 3">
                <div class="handleBtn" @click="collection()">
                    <div v-if="isCollection">
                        <img :src="imgObj.shou2" alt="">
                        <span class="blueSpan">已收藏</span>
                    </div>
                    <div v-else>
                        <img :src="imgObj.shou1" alt="">
                        <span>收&nbsp;藏</span>
                    </div>
                </div>
                <div class="handleBtn" @click="copyAnswer">
                    <div v-if="answerIsCopy">
                        <img :src="imgObj.fu2" alt="">
                        <span class="blueSpan">已复制</span>
                    </div>
                    <div v-else>
                        <img :src="imgObj.fu1" alt="">
                        <span>复制</span>
                    </div>
                </div>
            </div>
            <div class="bHandleRigth" @click="changeSSEStatus">
                <div v-if="sseStatus == 1">
                    <img :src="imgObj.tingzhi" alt="">
                    <span>停止生成</span>
                </div>
                <div v-if="sseStatus == 2">
                    <img :src="imgObj.jixu" alt="">
                    <span>继续生成</span>
                </div>
                <div v-if="sseStatus == 3">
                    <img :src="imgObj.shua" alt="">
                    <span>重新生成</span>
                </div>
            </div>
        </div>
        <div class="fascz" v-if="false">
            <div class="fasczContent">
                <p class="fTopText">方案正在生成中</p>
            </div>
        </div>
    </div>
</template>
<script>
//图片
import sseLogin from '@/assets/images/swjcw/ai-icon.png'
import shua from '@/assets/images/icon/shua.png'
import tingzhi from '@/assets/images/icon/tingzhi.png'
import jixu from '@/assets/images/icon/jixu.png'
import fu1 from '@/assets/images/icon/fu1.png'
import fu2 from '@/assets/images/icon/fu2.png'
import shou1 from '@/assets/images/icon/shou1.png'
import shou2 from '@/assets/images/icon/shou2.png'

//组件
import NnitMarkdown from '@/components/unit-markdown/unit-markdown.vue'

import { fetchEventSource } from '@microsoft/fetch-event-source'

//接口
import { sseCollection } from '@/api/api.js'

export default {
    name:'',
    components:{
        NnitMarkdown
    },
    props:['sendSEEObj','tIndez'],
    data(){
        return{
            imgObj:{
                sseLogin,
                shua,
                jixu,
                tingzhi,
                fu1,
                fu2,
                shou1,
                shou2
            },
            //分类名
            typeName:'稽查诊断',
            //问题 文字
            questionText:'',
            //文字打印状态 1-生成中 2-暂停生成 3-生成结束
            sseStatus:1,
            //是否收藏
            isCollection:false,
            collectionObj:{},
            //收藏分类
            collectionType:'',
            //sse请求分类
            sseCode:'',
            ctrl:'',
            eventSource:'',
            //是否复制
            answerIsCopy:false,
            markdownContent:'',
            markdownText:'',
            markdownH:'',
            //定时器
            addTextTimer:null,
            isHaveType:false,
            tTypeKey:'',
            tIndex:'',
        }
    },
    mounted(){
        //console.log(this.$props.sendSEEObj);
        //console.log(111,this.$props.tIndez);
        //是否有分类索引
        if(this.$props.tIndez!==''){
            //console.log('有',this.$props.tIndez);
            this.tIndex = this.$props.tIndez;
            //debugger
            this.tTypeKey = this.$props.sendSEEObj.tType;
        }
        //诊断分类名
        this.typeName = this.$props.sendSEEObj.sseTypeName;
        //收藏分类
        this.collectionType = this.$props.sendSEEObj.collectionType;
        //sse分类
        this.sseCode = this.$props.sendSEEObj.sseCode;
        //问题 文字
        this.questionText = this.$props.sendSEEObj.quesition;

        //是否有高度
        this.markdownH = this.$props.sendSEEObj.markdownH;

        this.$parent.isSSEing = true;
        //开始调用大模型
        this.getSeeAsk()
    },
    beforeDestroy(){
        //销毁时 清理一些函数
        this.destroySomeFn();
    },
    methods:{
        //markdown 展示文字 
        markdownShowText(){
            this.sseStatus = 1;
            this.addTextTimer = setInterval(() => {
                if(this.markdownText.length < this.markdownContent.length){
                    this.markdownText = this.markdownContent.substring(
                        0,
                        this.markdownText.length + 1
                    )
                }else{
                    //清除定时器
                    clearInterval(this.addTextTimer);
                    //加载完成 状态改为3
                    this.sseStatus = 3;
                    this.$parent.isSSEing = false;
                }
            }, 60)
        },
        //清理一些函数
        destroySomeFn(){
            //清除一些东西
            clearInterval(this.addTextTimer);
            if (this.ctrl) {
                //得先有实例才能停止
                this.ctrl.abort()
            }
        },

        getSeeAsk(){
            let that = this
            let sendData = {}
            sendData.code = this.sseCode
            sendData.ask = this.questionText
            let url = '/sseAI/round?auth_sign=eJw1jN0KgjAARt9l19Hm3LQJXZQlUgr9aFB3rrkcmplpWtG7J2KX3*Gc7wMCbz9*xiWwAB4jMOr3Q6RRUSjRwVZ-Zz6nyctxgsOsaQdDiTivlFR9yASVmtQl4RRFjGB2RsaEI4IIphJx-n9Vl05Ok60ywqUPd3N7swrWeQ2Vd5cNLxehfYKuU9-cYwv1NCPTIazUNQaWZmKGqYkNZprk*wMRkDZ6&auth_ts=1729257269774&auth_code=zsdy'
            this.ctrl = new AbortController()

            this.eventSource = new fetchEventSource(url, {
                // 这里设置请求头信息
                method: 'POST',
                body: JSON.stringify(sendData),
                headers: {
                    'Content-Type': 'application/json',
                },
                signal: this.ctrl.signal,
                onmessage(event) {
                    let obj = JSON.parse(event.data)
                    console.log('onmessage',obj)
                    if (obj.status == 0) {
                        //let content = obj.data.output.text || ''
                        let content = obj.data.message.content || ''
                        if (content) {
                            //let rc = content.replaceAll('\n', '<br>')
                            let rc = content
                            that.markdownContent += rc
                        }
                    } else {
                        console.log('出错了')
                    }
                },
                onopen (event){
                    console.log('onopen',event)
                    //console.log('触发start,开始打印文字')
                    //触发start,开始打印文字
                    setTimeout(() => {
                        that.markdownShowText()
                    },200)
                },
                onclose(ee) {
                // 关闭流
                    console.info('关闭了关闭了关闭了', ee);
                    if(that.tTypeKey!=''){
                        //先获取在存储
                        let getList = window.sessionStorage.getItem(that.tTypeKey);
                        if(getList&&getList.length!=0){
                            console.log('正常获取')
                            getList = JSON.parse(getList)
                        }else{
                            getList = [];
                        }
                        let newObj = {
                            questionText: that.questionText,
                            markdownText: that.markdownContent,
                        }
                        //getList[that.tIndex](newObj);
                        getList[that.tIndex] = newObj;
                        //存储
                        window.sessionStorage.setItem(that.tTypeKey,JSON.stringify(getList))
                    }
                },
                onerror(error) {
                    console.info(error, 'sssssssssss')
                    // this.stopSSE()
                    //返回流报错
                },
            })
        },
        //关闭当前的sse
        closeSSE(){
            console.log('关闭');
            this.$parent.isSSEing = false;
            this.$parent.jczdCloseSSE()
        },
        //点击复制 提问的文字
        async copyQuestion(){
            try {
                await navigator.clipboard.writeText(this.questionText);
                this.$message({
                    message:'文本已复制到剪贴板',
                    type:'success'
                })
            } catch (error) {
                this.$message({
                    message:'复制到剪贴板失败',
                    type:'error'
                })
            }
        },
        //点击复制 返回的文字
        async copyAnswer(){
            try {
                await navigator.clipboard.writeText(this.markdownContent);
                this.$message({
                    message:'文本已复制到剪贴板',
                    type:'success'
                })
                this.answerIsCopy = true;
            } catch (error) {
                this.$message({
                    message:'复制到剪贴板失败',
                    type:'error'
                })
            }
        },
        //收藏
        collection(){
            //
            if(this.isCollection==false){
                this.collectionAdd()
            }else{
                this.collectionCancel()
            }
        },
        //添加收藏
        collectionAdd(){
            let data = {}
            data.catalogCode = this.collectionType,
            data.text =  this.markdownText,
            data.title = this.questionText,
            sseCollection(data).then(res => {
                //console.log(res)
                if(res.status == 200&&res.data.status == 0){
                    this.collectionObj = res.data.data
                    this.$message({
                        message:'收藏成功',
                        type:'success',
                    })
                    this.isCollection = true;
                }else{
                    //console.log(res)
                    //未登录
                    if(res.data.status==401){
                        this.$message({
                            type:'warning',
                            message:'请先登录您的账号~',
                        })
                    }else{
                        this.$message({
                            type:'warning',
                            message:'收藏失败~',
                        })
                    }
                }
            })
        },
        //取消收藏
        collectionCancel(){
            let data = {}
            data.id = this.collectionObj.id;
            sseCollection(data).then(res => {
                if(res.status == 200 &&res.data.status == 0){
                    console.log(res)
                    this.$message({
                        message:'取消收藏',
                        type:'success',
                    })
                    this.isCollection = false;
                }
            })
        },
        //切换文字打印状态
        changeSSEStatus(){
            //正在生成时 点击实现暂停 清除打字效果 改变状态为-2
            if(this.sseStatus == 1){
                this.sseStatus = 2
                this.$parent.isSSEing = false;
                clearInterval(this.addTextTimer);
                //debugger
                if(this.tTypeKey!=''){
                    //console.log(this.tIndex);

                    //先获取在存储
                    let getList = window.sessionStorage.getItem(this.tTypeKey);
                    if(getList&&getList.length!=0){
                        console.log('正常获取')
                        getList = JSON.parse(getList)
                    }else{
                        getList = [];
                    }
                    let newObj = {
                        questionText: this.questionText,
                        markdownText: this.markdownText,
                    }
                    getList[this.tIndex] = newObj;
                    //存储
                    window.sessionStorage.setItem(this.tTypeKey,JSON.stringify(getList))
                }
            }else{
                //重新生成 要重头来 继续生成不用重来
                if(this.sseStatus == 3){
                    this.sseStatus = 1;
                    this.markdownContent = '';
                    this.markdownText = '';
                    clearInterval(this.addTextTimer)
                    //开始调用大模型
                    this.getSeeAsk()
                }else{
                    this.sseStatus = 1;
                    this.markdownShowText()
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.jczdView{
    width:100%;
    /*min-height: 520px;*/
    min-height: 1px;
    background: #ffffff;
    position: relative;
    .topNav{
        width:100%;
        height: 60px;
        background: #EEF8FF;
        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
        border-radius: 0px 0px 0px 0px;
        box-sizing: border-box;
        padding:10px;
        position: relative;
        .topNavLogo{
            width: 40px;
            height: 40px;
            float:left;
            border-radius:50%;
            img{
                width:100%;
                height:100%;
            }
        }
        .topNavText{
            width:calc(100% - 110px);
            height: 40px;
            line-height: 40px;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            box-sizing: border-box;
            margin-left:20px;
            float:left;
        }
        .topNavClose{
            width: 30px;
            height: 30px;
            background: #0F59A4;
            border-radius:50%;
            position: absolute;
            right:18px;
            top:15px;
            color: #ffffff;
            font-size: 30px;
            text-align: center;
            line-height: 26px;
            cursor:pointer;
        }
    }
    .topQuestionAndCopy{
        width:100%;
        // min-height: 60px;
        height:60px;
        margin-top:10px;
        overflow: hidden;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
        .questionContent{
            display: inline;
            min-height: 60px;
            //line-height: 60px;
            line-height: 24px;
            background: #0F59A4;
            box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
            border-radius: 8px 0px 8px 8px;
            float:right;
            box-sizing: border-box;
            //padding: 0 20px;
            padding:18px 20px;
            font-size: 16px;
            .questionText{
                display: inline;
                height: 60px;
                color:#ffffff;
            }
            .questionCopy{
                display: inline;
                padding:0 12px;
                height: 30px;
                color:#0F59A4;
                background: #EEF8FF;
                box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                margin-left:30px;
                text-align: center;
                cursor:pointer;
            }
        }
    }
    .showMarkDown{
        /*width:100%;*/
        width:810px;
        height:310px;
        margin-top:20px;
        overflow-y: auto;
        overflow-x: hidden;
        .markDownVontent{
            width:100%;
            width:810px;
            min-height: 0px;
            background: #EEF8FF;
            box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
            box-sizing: border-box;
            padding:10px 0;
        }
    }
    .aiText{
        width:100%;
        height:20px;
    }
    .bottomHandle{
        width:100%;
        height:45px;
        margin-top:20px;
        .bHandleLeft{
            width:300px;
            height:45px;
            float:left;
            -webkit-user-select: none;
            .handleBtn{
                width: 120px;
                height: 45px;
                line-height: 45px;
                background: #EEF8FF;
                box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
                border-radius: 23px 23px 23px 23px;
                margin-right:20px;
                float:left;
                text-align: center;
                cursor:pointer;
                img{
                    width:24px;
                    height:24px;
                    position: relative;
                    margin-right:10px;
                    top:5px;
                }
            }
        }
        .bHandleRigth{
            width: 140px;
            height: 45px;
            line-height: 45px;
            background: #0F59A4;
            box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
            float:right;
            cursor:pointer;
            text-align: center;
            color:#ffffff;
            img{
                width:24px;
                height:24px;
                position: relative;
                margin-right:10px;
                top:6px;
            }
        }
    }
}

.fascz{
    width:100%;
    height:230px;
    position: absolute;
    top:0;
    left:0;
    .fasczContent{
        width: 514px;
        height: 150px;
        background: #EEF8FF;
        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
        margin:76px auto 0;
        .fTopText{
            width:100%;
            height:80px;
            line-height: 80px;
            text-align: center;
            font-weight: 700;
            color: #0F59A4;
            font-size: 18px;
        }
    }
}


.blueSpan{
    color:#0F59A4;
}

</style>